import React, { FunctionComponent } from "react";
import styles from "./Card.module.scss";
import CardProps from "./CardProps.interface";

import getSpecialLink from "./helpers/getSpecialLink";

import { useInView } from "react-intersection-observer";
import combineClasses from "helpers/combine-classes";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import getImageCrop from "app/media/helpers/getImageCrop";
import ImageViewer from "components/ImageViewer/ImageViewer";
import Link from "components/Link/Link";
import Paragraph from "components/Paragraph/Paragraph";

const Card: FunctionComponent<CardProps> = (props) => {
    const [wrapperElementRef, inView] = useInView({ triggerOnce: false, threshold: 0.4, rootMargin: "50% -40px 50% 0px" });
    const isInViewClass = inView === true ? "in_view" : undefined;

    const image = props.content.image ? props.content.image : undefined;
    const imageCrop = getImageCrop(image?.umbracoFile.crops, props.imageCrop, "Fullscreen (4:3)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, image?.umbracoWidth, image?.umbracoHeight);

    const link = getSpecialLink(props.content.link);
    const hasLinkClass = link ? styles.has_link : undefined;

    return (
        <div className={combineClasses([styles.wrapper, isInViewClass])} ref={wrapperElementRef}>
            <Link className={combineClasses([styles.link, hasLinkClass])} link={link}>
                {/* Media */}
                {image ? (
                    <ImageViewer className={styles.image} crop={imageCrop} type="containX" src={image.umbracoFile.src} focalPoint={image.umbracoFile.focalPoint} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} alt={props.content.imageAlternative} />
                ) : null}

                <div className={styles.content}>
                    {/* Tagline */}
                    {props.content.tagline ? (
                        <span className={styles.tagline}>{props.content.tagline}</span>
                    ) : null}

                    {/* Heading */}
                    {props.content.heading ? (
                        <h3 className={styles.heading}>{props.content.heading}</h3>
                    ) : null}

                    {/* Text */}
                    {props.content.bodyText ? (
                        <Paragraph className={styles.text} innerHTML={props.content.bodyText} />
                    ) : null}
                </div>
            </Link>
        </div>
    );
};

export default Card;